module.exports = __webpack_public_path__ + "static/media/gateway-offline.d96533cd.svg";